import React from 'react'

import {
  CardContentShareWrapperData,
  GenerateAuthorizationTokenForContent,
  GenerateAuthorizationTokenForContentVariables,
  Visibility,
} from 'globalTypes'

import ShareContext from 'Root/Contexts/Share'
import apolloClient from 'lib/apollo-client'

import MUTATION from './generate-authorization-token-for-content.graphql'

interface Props {
  children: React.ReactNode
  content: CardContentShareWrapperData
  refetch?: Function
}

const ShareWrapper = ({ children, content, refetch }: Props) => {
  const link = `/c/${content.slug}`

  let callback
  if (content.visibility === Visibility.private && content.canManage) {
    callback = async () => {
      const { data } = await apolloClient.mutate<
        GenerateAuthorizationTokenForContent,
        GenerateAuthorizationTokenForContentVariables
      >({
        mutation: MUTATION,
        variables: {
          id: content.id,
        },
      })

      return `${link}?token=${data.token}`
    }
  }

  const value = {
    callback,
    canManage: content.canManage,
    text: content.description || undefined,
    title: content.title || undefined,
    type: content.__typename,
    refetch: refetch,
    visibility: content.visibility || undefined,
    url: link,
  }

  return <ShareContext.Provider value={value}>{children}</ShareContext.Provider>
}

export default ShareWrapper
